/**
 * #3010 LIVEDOWN: the provenance every live-routed Ostendo response carries
 * (server: ostendoProvenance in lib/ostendo-route.ts), shared so the pages and
 * the server agree on what "live unavailable" means.
 *
 * `ostendo_source` says which database answered. `ostendo_reason` says why:
 * `live_failed` is the one reason that means the page wanted live and could
 * not have it (a live read failed now, or within the last five minutes), so
 * the copy it got is a fallback, not the plan. Every other copy reason
 * (`no_key`, `budget`, `kv_error`, `not_eligible`) is a copy by design and
 * keeps the plain copy date.
 */
export type OstendoSourceWire = "live" | "copy";
export type OstendoReasonWire = "live" | "not_eligible" | "no_key" | "kv_error" | "live_failed" | "budget";

export interface OstendoProvenance {
  ostendo_source?: OstendoSourceWire | null;
  ostendo_reason?: OstendoReasonWire | null;
}

/** The copy answered because live failed: the page must say live is unavailable. */
export function isLiveUnavailable(p: OstendoProvenance | null | undefined): boolean {
  return p?.ostendo_source === "copy" && p.ostendo_reason === "live_failed";
}
